import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import Page from "components/Page";
import { Link } from "react-router-dom";
import constants from "../../../../constants";
import { useOfficeDetail } from "repositories/office-repository";
import { useStaffMembers } from "repositories/contract-repository";
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import Loader from "components/Loader";
import Empty from "components/Empty";
import { decodeId, encodeId, setCacheLocalstorage } from "utils";
import styles from "./Contracts.module.scss";
import Text from "components/Text";
import SearchIcon from "assets/images/search.svg";
import CloseIcon from "assets/images/close-icon.svg";

function Contracts({ history, location, match, t }) {
  const officeId = decodeId(match.params.officeId);
  const PAGE_SIZE = 20;
  const [pageNumber, setPageNumber] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  const goBack = () =>
    history.push(
      constants.routes.accountOwner.forms.replace(
        ":officeId",
        match.params.officeId,
      ),
    );
  let officeName = null;
  if (location.state && location.state.officeName) {
    officeName = location.state.officeName;
  }

  const { isLoading: isLoadingStaff, data: officeStaff } = useStaffMembers(
    officeId,
    searchTerm,
    pageNumber,
    PAGE_SIZE,
  );
  const { isLoading: isLoadingOfficeDetail, data: officeDetail } =
    useOfficeDetail(officeId);

  let rows = [];
  let totalItems = 0;

  if (!isLoadingStaff && officeStaff && officeStaff.items) {
    rows = officeStaff.items;
    totalItems = officeStaff.pagination.totalItems;
  }

  const handleSearchTerm = (event) => {
    setSearchTerm(event.target.value);
    setPageNumber(1);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setPageNumber(1);
  };

  return (
    <Page
      onBack={goBack}
      isTitleLoading={
        !officeName && !officeStaff && (isLoadingOfficeDetail || isLoadingStaff)
      }
      title={t("contracts.formsAndContract")}
      className={styles["page"]}
    >
      {(isLoadingOfficeDetail || isLoadingStaff) && <Loader />}
      <Text size="14" weight="300" color="#000000">
        {officeName || (officeDetail && officeDetail?.name)}
      </Text>
      <div className={styles["new_search_bar"]}>
        <span className={styles["search_icon"]}>
          <img src={SearchIcon} alt="search icon" />
        </span>
        <input
          className={styles["search_input"]}
          type="text"
          placeholder={t("contracts.searchByStaffName")}
          onChange={handleSearchTerm}
          value={searchTerm}
        />
        {searchTerm.trim() && (
          <button
            type="button"
            className={styles["clear_button"]}
            onClick={handleClearSearch}
            aria-label="Clear search"
          >
            <img src={CloseIcon} alt="clear search" />
          </button>
        )}
      </div>
      {rows.length > 0 && (
        <div className="mange-sub-section">
          <ul className={styles["contract-data-list"]}>
            {rows.map((data, key) => (
              <li
                key={key}
                onClick={() => {
                  setCacheLocalstorage(
                    constants.contracts.contractslocalstorageKey,
                    {
                      staffName: data.firstName + " " + data.lastName,
                      staffContractEmploymentDate: data?.employmentDate || "",
                      userId: data.userId,
                      annualSalary: data.annualSalary,
                      commission: data.commission,
                      commissionType: data.commissionType,
                      bonus: data.bonus,
                      bonusType: data.bonusType,
                      ownerId: officeDetail?.owner?.id,
                      designation: data.designation,
                      address: [
                        data?.user?.address || data?.user?.streetAddress,
                        data?.user?.city?.name || "",
                        data?.user?.state?.name || "",
                        data?.user?.country?.name || "",
                        data?.user?.postalCode
                          ? `(${data?.user?.postalCode})`
                          : "",
                      ].reduce((prev, res, i, arr) => {
                        if (!res?.trim()) return prev;
                        if (!i) {
                          return (prev += res + (arr.length > 1 ? "," : ""));
                        }
                        if (arr.length - 1 === i) {
                          return (prev += ` ${res}`);
                        }
                        return (prev += ` ${res},`);
                      }, ""),
                    },
                    true,
                  );
                }}
              >
                <Link
                  className={styles["contract-link"]}
                  to={{
                    pathname: constants.routes.accountOwner.staffContracts
                      .replace(":officeId", match.params.officeId)
                      .replace(":staffId", encodeId(data.id)),
                    state: location.state,
                  }}
                >
                  <label className={styles["contract-name"]}>
                    {data.firstName} {data.lastName}
                  </label>
                  <span className={styles["contract-btn"]}>
                    {" "}
                    {t("contracts.viewContract")}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
          <PaginationProvider
            pagination={paginationFactory({
              custom: true,
              sizePerPage: PAGE_SIZE,
              totalSize: totalItems,
              page: pageNumber,
              onPageChange: setPageNumber,
            })}
          >
            {({ paginationProps, paginationTableProps }) => {
              return (
                <div className="data-table-block">
                  {/* Paginator component needs table to work, this is why we have used it.  */}
                  <div style={{ display: "none" }}>
                    <BootstrapTable
                      keyField="id"
                      data={[]}
                      columns={[{ text: "sometext" }]}
                      {...paginationTableProps}
                    />
                  </div>

                  <div
                    className={
                      "pagnation-block " + styles["mobile-align-center"]
                    }
                  >
                    {totalItems > PAGE_SIZE && (
                      <PaginationListStandalone {...paginationProps} />
                    )}
                  </div>
                </div>
              );
            }}
          </PaginationProvider>
        </div>
      )}
      {rows.length === 0 && <Empty Message={t("noStaffMemberFound")} />}
    </Page>
  );
}
export default withTranslation()(Contracts);
